// src/firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyBOngxhy6kRXToP0ov2qk0CfRC8NU919T0",
  authDomain: "chez-papy.firebaseapp.com",
  projectId: "chez-papy",
  storageBucket: "chez-papy.firebasestorage.app",
  messagingSenderId: "519887880032",
  appId: "1:519887880032:web:c1c3becab3a3dcae816805"
  
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);
const storage = getStorage(app);

export { auth, db, storage };
